import { useEffect, useState } from 'react';
import api from '../../services/api';

/** Champs du projet envoyés à l'IA (comme données, jamais comme consignes). */
export const projectInput = (formData, countryName) => ({
  title: formData.title,
  description: formData.description,
  businessModel: formData.businessModel,
  targetMarket: formData.targetMarket,
  competitiveAdvantage: formData.competitiveAdvantage,
  category: formData.category,
  stage: formData.stage,
  country: countryName || formData.country,
  fundingNeeded: formData.fundingNeeded,
  currency: formData.currency,
  teamSize: formData.teamSize,
  timeline: formData.timeline,
});

// ── Crédits IA (solde commun à toute la plateforme) — affichage seulement ─────────
// Le serveur et la base décomptent et refusent eux-mêmes. Gardé en mémoire pour la session.

export const LIEN_CREDITS = 'https://app.innovactive360.cloud/achats/nouveau';

let solde = null;
let chargement = null;
const abonnes = new Set();

const majCredits = (c) => {
  if (!c || typeof c !== 'object') return;
  solde = { total: Number(c.total) || 0, rechargeLe: c.rechargeLe || null, couts: c.couts || {} };
  abonnes.forEach((f) => f(solde));
};

/** Solde courant ; chargé une fois par session (GET /api/ai/credits). */
export const useCreditsIA = () => {
  const [c, setC] = useState(solde);
  useEffect(() => {
    abonnes.add(setC);
    if (!solde && !chargement) {
      chargement = api.get('/ai/credits')
        .then(({ data }) => majCredits(data?.credits))
        .catch(() => { chargement = null; });
    }
    return () => { abonnes.delete(setC); };
  }, []);
  return c;
};

/** « 12 crédits restants », et le coût si le solde ne suffit pas. */
export const soldeLabel = (credits, tache) => {
  if (!credits) return null;
  const cout = Number(credits.couts?.[tache]) || 0;
  const base = `${credits.total} crédit${credits.total > 1 ? 's' : ''} IA restant${credits.total > 1 ? 's' : ''}`;
  return cout > credits.total ? `${base} — il en faut ${cout} pour une proposition.` : `${base}.`;
};

export const creditsInsuffisants = (credits, tache) => Boolean(credits) && (Number(credits.couts?.[tache]) || 0) > credits.total;

/**
 * Demande une proposition de rédaction (POST /api/ai/write). Rien n'est enregistré.
 * 2 crédits IA par proposition, rendus si l'IA échoue.
 * @returns {Promise<{ proposal: object }>}
 */
export const requestProposal = async (task, input) => {
  try {
    const { data } = await api.post('/ai/write', { task, input }, { timeout: 70000 });
    majCredits(data.credits);
    return { proposal: data.proposal };
  } catch (err) {
    majCredits(err.response?.data?.credits);
    throw new Error(err.response?.data?.message || 'L\'IA n\'a pas pu proposer de texte. Réessayez.');
  }
};
